<template>
  <div class="card">
    <div class="card-header">
      <h6>User Overview</h6>
    </div>
    <div class="card-body row">
      <div class="col-12 d-flex justify-content-center mb-3">
        <div :style="{'backgroundImage': 'url('+(data.user.photo != null ? image_from_server(data.user.photo.file_name) : '')+')'}" style="background-size: cover; background-position: center; height: 10rem; width: 10rem" class="rounded-circle"></div>
      </div>
      <div class="col-6">Name</div>
      <div class="col-6">{{ data.user.name }}</div>

      <div class="col-6">ID</div>
      <div class="col-6">{{ data.user.id }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data',],
  methods: {
    image_from_server(file_name){
      return base_url+'/images/user?file_name='+file_name
    },
  }
}
</script>
